module.exports = __webpack_public_path__ + "img/mail-icon.85f0e6b5.svg";